export default {
  'pointHistory.title': 'ポイント履歴',
  'pointHistory.event.deduct': 'ポイント減算',
  'pointHistory.event.collect': 'ポイント獲得',
  'pointHistory.event.transfer': 'ポイント譲渡',
  'pointHistory.event.0': 'ポイント付与対象外',
  'pointHistory.event.1': '一定金額以上でポイント付与',
  'pointHistory.event.4': '柔軟なポイント付与',
  'pointHistory.event.10': '柔軟なポイント減算',
  'pointHistory.event.20': '自動クーポン変換によるポイント減算',
  'pointHistory.event.21': 'クーポン選択によるポイント減算',
  'pointHistory.event.22': 'ポイント有効期限切れ',
  'pointHistory.event.90': 'ポイント加算の取り消し',
  'pointHistory.event.91': '取引キャンセルによるポイント減算',
  'pointHistory.event.92': '取引キャンセル - 自動クーポン変換ポイント返還',
  'pointHistory.event.93': 'ポイント付与の取り消し',
  'pointHistory.event.94': 'ポイント減算の取り消し',
  'pointHistory.message.cancel_success': 'ポイント取消成功',
  'pointHistory.message.cancel_fail': 'ポイント取消失敗',
  'pointHistory.current_points': '現在のポイント',
  'pointHistory.expiration_date': '有効期限',
  'pointHistory.button.cancel': 'キャンセル',
  'pointHistory.empty': 'データなし',
  'pointHistory.point_detail': 'ポイント詳細',
  'pointHistory.processing_time': '処理時間',
  'pointHistory.remark': '備考',
  'pointHistory.consumption_amount': '利用金額',
  'pointHistory.bottomDateRange.dateFrom': '開始日',
  'pointHistory.bottomDateRange.dateTo': '終了日',
  'pointHistory.bottomDateRange.error.dateFrom': '開始日を選択してください',
  'pointHistory.bottomDateRange.error.dateTo': '終了日を選択してください',
  'pointHistory.bottomDateRange.error.dateRange': '開始日は終了日より後の日付を設定できません',
  'pointHistory.bottomDateRange.search': '検索',
  'pointHistory.bottomDateRange.cancel': 'キャンセル',
} as Record<string, string>;
